import { useEffect } from 'react';
import { TimedDismissState } from '../types';

interface UsePermanentDismissOnVisitParams {
  dismissState: TimedDismissState;
  isOnCallIntelligenceRoute: boolean;
  onDismiss: (state: TimedDismissState) => void;
  shouldDismiss: boolean;
}

/**
 * Permanently dismisses a timed banner when the user visits the Call Intelligence route while the banner was only temporarily dismissed.
 */
export const usePermanentDismissOnVisit = ({
  dismissState,
  isOnCallIntelligenceRoute,
  onDismiss,
  shouldDismiss,
}: UsePermanentDismissOnVisitParams) => {
  useEffect(() => {
    if (isOnCallIntelligenceRoute && shouldDismiss && dismissState.dismissedAt && !dismissState.permanentlyDismissed) {
      onDismiss({ permanentlyDismissed: true });
    }
  }, [dismissState, isOnCallIntelligenceRoute, onDismiss, shouldDismiss]);
};
